import React from 'react';
export function Footer() {
  return <footer className="w-full bg-plum-deep" data-id="element-96" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto px-5 py-12 text-center" data-id="element-97" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl font-bold text-white" data-id="element-98" data-mp="3ghc2o28413o8">
          Dance Class <span className="text-gold" data-id="element-99" data-mp="32pfh6h0y5s0t">Ready</span>
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-100" data-mp="36oxwmxa01aw9">
          The Flex-Level Class Method — because teaching dance shouldn&apos;t
          cost you every evening of the week.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/70" data-id="element-101" data-mp="38zbay6h7b62">
          <a href="mailto:help@iclcollective.com" className="hover:text-white hover:underline" data-id="element-102" data-mp="3ldamdcihtxib">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-plum-line pt-5 text-xs leading-relaxed text-white/45" data-id="element-103" data-mp="29yxc5agnxgkr">
          Dance Class Ready is an educational resource for dance teachers. It
          does not replace teacher training, first-aid certification,
          safeguarding requirements or the policies of your studio, school or
          venue. Activities are designed for recreational groups of children
          aged 6–12 under the supervision of a responsible adult; stop any
          activity that causes pain and refer to a health professional when
          needed. Music is referenced by tempo and style only — you are
          responsible for using music you are licensed to play. Not affiliated
          with any dance organization, syllabus or brand. © Dance Class Ready
          2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}